import { AWSConnectorService } from './aws-connector';
import { BrightLocalService } from './bright-local.service';
import { UnitSizes } from './../models/unitSizes';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { Router } from "@angular/router";
import { Client } from "../models/client";
import { PageSettings } from "../models/pageSettings";
import { ComponentSettings } from "../models/componentSettings";
import { MdSnackBar } from "@angular/material";
import { Email } from "../models/email";
import { Hour } from "../models/hour";
import { MobileSettings } from '../models/MobileSettings';
import { environment } from "../../environments/environment";
import { Http, RequestOptions } from "@angular/http";
import { LocationInfo } from "../models/locationInfo";
import { HttpHeaders } from '@angular/common/http';
import { CustomPageData } from '../models/customPageData';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import * as _ from 'lodash';
import { Subject } from 'rxjs/Subject';
import { first } from 'rxjs/operators';
declare const gapi: any;
var AWS = require('aws-sdk');
AWS.config.update(environment.aws);
var sqs = new AWS.SQS();

@Injectable()
export class FirebaseService {
  isLoggedIn: boolean = false;
  facilities: Array<Client> = [];
  facilityKeys = {};
  users: FirebaseListObservable<any>;
  selectedClient: Client;
  isLoading = false;
  private headers: any;
  private options: any;
  private baseUrl: string = environment.lambdaApi;
  private _facilityKeysLoaded = new BehaviorSubject<boolean>(false);
  private _facilitiesLoaded = new BehaviorSubject<boolean>(false);
  private _facilityStats = {};
  private _numLocations;
  private _totals = {};
  facilitiesLoaded = false;
  facilityChunkLoaded = new Subject<any[]>();
  reviewSettingsSubmittedCount = 0;
  globalReviewsLoading = false;
  isLocation = false;
  clientKey: string;
  isBilly = false;
  //locationData: LocationInfo;


  constructor(
    public auth: AngularFireAuth,
    public db: AngularFireDatabase,
    public router: Router,
    public snackBar: MdSnackBar,
    private http: Http,
    private bl: BrightLocalService,
    private aws: AWSConnectorService
  ) {
    this.auth.authState.subscribe((auth: any) => {
      if (auth) {
        this.isLoggedIn = true;
        if (auth.email && auth.email.includes('billy')) {
          this.isBilly = true;
        }
        this.getAllUsers();
        this.setGoogleAuth();
        this._facilitiesLoaded
          .pipe(first(loaded => loaded))
          .subscribe(loaded => this.facilitiesLoaded = loaded);
        this.getFacilityKeys().then(() => this.getFacilities());
      }
      else {
        this.isLoggedIn = false;
        this.router.navigate(['login']);
      }
    });
  }

  updateSettingsOnServer(clientData: Client) {
    var params = {
      MessageBody: environment.env,
      QueueUrl: 'https://sqs.us-east-1.amazonaws.com/729153069069/update-settings-to-client',
      DelaySeconds: 0,
      MessageAttributes: {
        clientCode: {
          DataType: 'String',
          StringValue: clientData.code
        },
      }
    };
    sqs.sendMessage(params, (err, data) => {
      if (err) {
        console.log(err, err.stack);
        this.openSnackBar('ERROR: see console');
      }
      else {
        console.log(data);
        this.openSnackBar('Update settings added to SQS queue.');
      }
    });
  }

  setGoogleAuth() {

  }

  async getTotalLocations() {
    if (!this._numLocations) {
      const locations = (await this.db.database.ref('locations').once('value')).val();
      this._numLocations = 0;
      _.each(locations, val => {
        try {
          this._numLocations += _.keys(val).length;
        }
        catch (error) {
          console.warn('Error caught counting locations:', error);
        }
      });
    }

    return this._numLocations;
  }

  async getTotalUnitsRented() {
    if (!this._totals['unitsRented']) {
      this._totals['unitsRented'] = (await this.db.database.ref('totals/unitsRented').once('value')).val();
    }
    return this._totals['unitsRented'];
  }

  async getTotalPayments() {
    if (!this._totals['payments']) {
      this._totals['payments'] = (await this.db.database.ref('totals/payments').once('value')).val();
    }
    return this._totals['payments'];
  }

  async getTotalUnitsReserved() {
    if (!this._totals['unitsReserved']) {
      this._totals['unitsReserved'] = (await this.db.database.ref('totals/unitsReserved').once('value')).val();
    }
    return this._totals['unitsReserved'];
  }

  async getFacilityStats(clientKey) {
    if (!this._facilityStats[clientKey]) {
      this._facilityStats[clientKey] = (await this.db.database.ref('dashboardTotals/' + clientKey).once('value')).val();
    }
    return this._facilityStats[clientKey];
  }

  getClientInfo(clientKey: string) {
    return this.db.object('/facilities/' + clientKey);
  }

  getThemes() {
    return this.db.object('/themes');
  }

  getOnboardingSubmissions() {
    return this.db.list('/onboardingWebhook');
  }

  getOnboardingLocation(onboardingKey, clientKey, locationKey): Promise<any> {
    return new Promise((resolve, reject) => {
      this.db.object(`onboardingWebhookAdded/${ clientKey }`)
        .subscribe(data =>
          resolve(_.find(data, o => o.locationInformation && o.locationInformation.origKey === onboardingKey)),
          err => reject(err));
    });
  }

  setOnboardingLocation(key, onboardingLocation, clientKey, locationKey) {
    let sub = this.db.object('/onboardingWebhook/' + key).subscribe(async (loc) => {
      console.log('setOnboardingLocation', loc);
      sub.unsubscribe();
      await this.db.object('onboardingWebhookAdded/' + clientKey + "/" + locationKey)
        .set({
          hubspot: loc,
          locationInformation: onboardingLocation
        });
      await this.db.object('/onboardingWebhook/' + key).remove();
    });
  }

  updateCounts(client: Client, numLocations: number) {
    _.unset(this.facilityKeys, client.code);
    this.facilities = _.filter(this.facilities, (f: Client) => f.code !== client.code);
    this._numLocations -= numLocations;
  }

  facilitiesLoadedPromise() {
    return new Promise<void>(resolve => {
      const sub = this._facilitiesLoaded.subscribe(loaded => {
        if (loaded) {
          resolve();
          if (sub && !sub.closed) {
            sub.unsubscribe();
          }
        }
      });
    });
  }

  getFacilities() {
    // create a 2D array of facilityKeys and clientCodes [[clientCode, facilityKey], [clientCode, facilityKey], ...]
    const pairs = _.toPairs(this.facilityKeys);
    const chunkLength = Math.ceil(10 / pairs.length * 100);
    // break the array into an array of chunks
    const chunks = _.chunk(pairs, chunkLength);
    console.time('facilities');
    for (let chunk of chunks) {
      let newFacilities = [];
      // query for a range of client data
      this.db.database.ref('facilities')
        .orderByChild('code')
        .startAt(chunk[0][0])
        .endAt(chunk[chunk.length - 1][0])
        .once('value').then(facilityChunk => {
          facilityChunk.forEach(f => {
            let tmp = f.val();
            // add a readonly $key variable on each client that gets used around this app
            Object.defineProperty(tmp, '$key', {
              value: f.ref.key,
              enumerable: false
            });
            newFacilities.push(tmp);
          });
          // append the new chunk of client data
          this.facilities = this.facilities.concat(newFacilities);
          // send the new chunk to any component that needs it immediately
          this.facilityChunkLoaded.next(newFacilities);
          // this is how we know we are done
          if (this.facilities.length === _.keys(this.facilityKeys).length) {
            console.timeEnd('facilities');
            console.timeEnd('keysAndFacilities');
            this._facilitiesLoaded.next(true);
          }
        });
    }
  }

  facilityKeysLoadedPromise() {
    return new Promise<void>(resolve => {
      this._facilityKeysLoaded.subscribe(loaded => {
        if (loaded) {
          resolve();
        }
      });
    });
  }

  async getFacilityKeys() {
    console.time('facilityKeys');
    console.time('keysAndFacilities');
    this.facilityKeys = (await this.db.database.ref('facilityKeys').orderByKey().once('value')).val();
    this._facilityKeysLoaded.next(true);
    console.timeEnd('facilityKeys');
  }

  getAllUsers() {
    this.users = this.db.list('users');
  }

  saveClient(client) {
    return this.db.list('facilities').push(client);
  }

  saveClientKey(clientKey, code) {
    return this.db.object('facilityKeys/' + code).set(clientKey);
  }

  updateClient(client, key?) {
    return this.db.list('facilities').update(key || client.$key, client);
  }

  async updateClientSoftware(client, isNew) {
    const obj = (await this.db.database.ref('facilitiesByPropertySoftware').once('value')).val()
    if (isNew && client.propertySoftware) {
      if (obj[client.propertySoftware]) {
        obj[client.propertySoftware].push(client.code)
      }
      else {
        obj[client.propertySoftware] = [client.code]
      }
      await this.db.object('facilitiesByPropertySoftware').set(obj)
    }
    else {
      console.log("🚀 ~ file: firebase.service.ts ~ line 288 ~ FirebaseService ~ updateClientSoftware ~ obj[client.propertySoftware]", obj[client.propertySoftware])
      const i = _.findIndex(obj[client.propertySoftware], c => c === client.code)
      console.log("🚀 ~ file: firebase.service.ts ~ line 288 ~ FirebaseService ~ updateClientSoftware ~ i", i)
      if (i === -1) {
        for (let p in obj) {
          if (p !== client.propertySoftware) {
            let j = _.findIndex(obj[p], c => c === client.code)
            if (j > -1) {
              _.remove(obj[p], c => c === client.code)
              break
            }
          }
        }
        if (client.propertySoftware) {
          if (obj[client.propertySoftware]) {
            obj[client.propertySoftware].push(client.code)
          }
          else {
            obj[client.propertySoftware] = [client.code]
          }
          await this.db.object('facilitiesByPropertySoftware').set(obj)
        }
      }
    }
  }

  async removeClientSoftware(client) {
    const obj = (await this.db.database.ref('facilitiesByPropertySoftware').once('value')).val()
    for (let p in obj) {
      if (p !== client.propertySoftware) {
        let j = _.findIndex(obj[p], c => c === client.code)
        if (j > -1) {
          _.remove(obj[p], c => c === client.code)
          break
        }
      }
    }
    await this.db.object('facilitiesByPropertySoftware').set(obj)
  }

  updateClientDataModel(client, model, data) {
    return this.db.object('facilities/' + client.$key + '/' + model).set(data);
  }

  updateFacilityUser(facilityUser) {
    return this.db.list('users').update(facilityUser.$key, facilityUser);
  }

  createFacilityUser(facilityUser, key) {
    return this.db.object('users/' + key).set(facilityUser);
  }

  updateClientForms(locationData, clientKey, locationKey) {
    return this.db.object('locations/' + clientKey + '/' + locationKey).update(locationData);
  }

  getLocations(client) {
    return this.db.list('locations/' + client.$key);
  }

  getLocationsFromClientCode(clientCode) {
    return this.db.list('locations/' + clientCode);
  }

  getLocationsByKey(key) {
    return this.db.list('locations/' + key);
  }

  createAUser(email, password) {
    return this.auth.auth.createUserWithEmailAndPassword(email, password)
  }

  getLocationInfo(clientKey, locationKey) {
    return this.db.object('locations/' + clientKey + '/' + locationKey);
  }

  getLocationInfoPromise(clientKey, locationKey): Promise<LocationInfo> {
    return new Promise((resolve, reject) => {
      this.db.object('locations/' + clientKey + '/' + locationKey)
        .subscribe(locationData => resolve(locationData), error => reject(error));
    });
  }

  getLocationForms(clientKey, locationKey) {
    return this.db.list('locationForms/' + clientKey + '/' + locationKey);
  }

  getLocationForm(clientKey, locationKey, formKey) {
    return this.db.object('locationForms/' + clientKey + '/' + locationKey + '/' + formKey);
  }

  newLocationForm(clientKey, locationKey, locationForm) {
    return this.db.list('locationForms/' + clientKey + '/' + locationKey).push(locationForm);
  }

  updateLocationForm(clientKey, locationKey, locationForm) {
    return this.db.object('locationForms/' + clientKey + '/' + locationKey + '/' + locationForm.$key).update(locationForm);
  }

  removeLocationForm(clientKey, locationKey, locationForm) {
    return this.db.object('locationForms/' + clientKey + '/' + locationKey + '/' + locationForm.$key).remove();
  }

  getLocationEsignInfo(clientKey, locationKey) {
    return this.db.object('locationsEsignInfo/' + clientKey + '/' + locationKey);
  }

  saveLocationEsignInfo(client, locationEsignInfo, key) {
    return this.db.object('locationsEsignInfo/' + client.$key + '/' + key).set(locationEsignInfo);
  }

  getLocationGateHours(clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/gateHours');
  }

  savePageSettings(client, pageSettings: PageSettings) {
    return this.db.object('facilities/' + client.$key + '/pages').update(pageSettings);
  }

  updateSizeGuideSetting(clientKey, unitSize: UnitSizes[]) {
    return this.db.object('facilities/' + clientKey + '/pages/sizeGuide/sizes').set(unitSize);
  }

  updateSizeGuideSettingIndex(clientKey, unitSize) {
    return this.db.object('facilities/' + clientKey + '/pages/sizeGuide/sizesIndex').set(unitSize);
  }

  updateLocationSizeGuideSettingIndex(clientKey, locationCode, unitSize) {
    return this.db.object('locations/' + clientKey + '/' + locationCode + '/sizeGuide/sizesIndex').update(unitSize);
  }

  getLocationSizeGuideSettingIndex(clientKey, locationCode) {
    return this.db.object('locations/' + clientKey + '/' + locationCode + '/sizeGuide/sizesIndex');
  }

  removeSizeGuideSettings(clientKey) {
    return this.db.list('facilities/' + clientKey + '/pages/sizeGuide/sizes').remove();
  }

  removeLocationSizeGuideSettings(clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/sizeGuide/sizes').remove();
  }

  loadPageSettings(clientKey) {
    return this.db.object('facilities/' + clientKey + '/pages');
  }

  loadMobileSettings(clientKey, locationKey) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/mobileSettings');
  }

  saveMobileSettings(client, locationKey, mobileSettings: MobileSettings) {
    return this.db.object('locations/' + client.$key + '/' + locationKey + '/mobileSettings').update(mobileSettings);
  }

  saveComponentSettings(client, componentSettings: ComponentSettings) {
    return this.db.object('facilities/' + client.$key + '/components').update(componentSettings);
  }

  loadComponentSettings(clientKey) {
    return this.db.object('facilities/' + clientKey + '/components');
  }

  saveReviewSettings(clientKey, locationKey, settings) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/reviewSettings').update(settings);
  }

  saveFacilityReviewSettings(clientKey, settings) {
    return this.db.object('facilities/' + clientKey + '/reviewSettings').update(settings);
  }

  loadReviewSettings(clientKey, locationKey) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/reviewSettings');
  }

  // loadReviewSettings(clientKey) {
  //   return this.db.object('facilities/' + clientKey + '/reviewSettings');
  // }

  saveReviews(clientKey, locationKey, settings) {
    console.log(clientKey, locationKey, settings)
    if (clientKey != null) {
      return this.db.object('locations/' + clientKey + '/' + locationKey + '/reviews').update(settings);
    }
    else {
      return Promise.resolve(null);
    }
  }

  saveReviewsFacility(clientKey, locationKey, settings) {
    console.log(clientKey, locationKey, settings)
    if (clientKey != null) {
      return this.db.object('facilities/' + clientKey + '/reviews/' + locationKey).update(settings);
    }
    else {
      return Promise.resolve(null);
    }
  }


  // saveReviews(clientKey, settings) {
  //   return this.db.object('facilities/' + clientKey + '/reviews').update(settings);
  // }

  loadLocationSmallPrimaryIconBar(clientKey, locationKey) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/smallPrimaryIconBar');
  }

  saveLocationSmallPrimaryIconBar(clientKey, locationKey, data) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/smallPrimaryIconBar').update(data);
  }

  saveLocationSummary(clientKey, locationKey, data, which) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/' + which + 'Summary').set(data);
  }

  loadLocationFeaturesIconBar(clientKey, locationKey) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/featuresComponent');
  }

  saveLocationFeaturesIconBar(clientKey, locationKey, data) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/featuresComponent').set(data);
  }

  saveMainNavItems(clientKey, val) {
    return this.db.object('facilities/' + clientKey + '/navigation').update(val);
  }

  saveLocationNavItems(clientKey, locationKey, val) {
    return this.db.object('locations/' + clientKey + '/' + locationKey + '/navigation').set(val);
  }

  getFacilityNavItems(clientKey, locationKey?) {
    if (locationKey) {
      return this.db.list('locations/' + clientKey + '/' + locationKey + '/navigation');
    }
    else {
      return this.db.list('facilities/' + clientKey + '/navigation');
    }
  }

  saveNavItem(client, navItem, location?) {
    if (location) {
      return this.db.list('locations/' + client.$key + '/' + location.$key + '/navigation').push(navItem);
    }
    else {
      return this.db.list('facilities/' + client.$key + '/navigation').push(navItem);
    }
  }

  updateNavItem(client, navItem, location?, locationNavKey?) {
    if (location) {
      return this.db.list('locations/' + client.$key + '/' + location.$key + '/navigation').update((locationNavKey || navItem.$key), navItem);
    }
    return this.db.list('facilities/' + client.$key + '/navigation').update(navItem.$key, navItem);
  }

  updateNavItemWithSeparateKey(client, navItemKey, navItem) {
    return this.db.list('facilities/' + client.$key + '/navigation').update(navItemKey, navItem);
  }

  deleteNavItem(client, navItem) {
    return this.db.list('facilities/' + client.$key + '/navigation/' + navItem.$key).remove();
  }

  getClientEmailList(clientKey, emailName, locationKey) {
    return this.db.list('emails/' + clientKey + '/' + locationKey + '/' + emailName);
  }

  saveEmailToList(client, emailName, email: Email, locationKey) {
    return this.db.list('emails/' + client.$key + '/' + locationKey + '/' + emailName).push(email);
  }

  updateEmailList(client, emailName, email: Email, locationKey) {
    return this.db.list('emails/' + client.$key + '/' + locationKey + '/' + emailName).update(email.$key, email);
  }

  deleteEmailFromList(client, emailName, email: Email, locationKey) {
    return this.db.list('emails/' + client.$key + '/' + locationKey + '/' + emailName + '/' + email.$key).remove();
  }

  getLocationOfficeHours(clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/hours');
  }

  getMainOfficeHours(clientKey) {
    return this.db.list('facilities/' + clientKey + '/hours');
  }

  getMainGateHours(clientKey) {
    return this.db.list('facilities/' + clientKey + '/gateHours');
  }

  saveOfficeHour(hour, clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/hours').push(hour);
  }

  updateOfficeHour(hour, clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/hours').update(hour.$key, hour);
  }

  deleteOfficeHour(hour, clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/hours/' + hour.$key).remove();
  }

  getCustomPages(clientKey) {
    return this.db.list('facilities/' + clientKey + '/customPages');
  }

  getCustomPage(clientKey, pageKey) {
    return this.db.object('facilities/' + clientKey + '/customPages/' + pageKey);
  }

  saveCustomPage(page: CustomPageData, clientKey) {
    page.route = page.name.replace(/\W+/g, '-').toLowerCase();
    return this.db.list('facilities/' + clientKey + '/customPages/').push(page);
  }

  updateCustomPage(page, clientKey) {
    return this.db.list('facilities/' + clientKey + '/customPages/').update(page.$key || page.key, page);
  }

  deleteCustomPage(page, clientKey) {
    return this.db.list('facilities/' + clientKey + '/customPages/' + page.$key).remove();
  }

  saveGateHour(hour, clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/gateHours').push(hour);
  }

  updateGateHour(hour, clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/gateHours').update(hour.$key, hour);
  }

  deleteGateHour(hour, clientKey, locationKey) {
    return this.db.list('locations/' + clientKey + '/' + locationKey + '/gateHours/' + hour.$key).remove();
  }

  saveLocation(client, location, key) {
    return this.db.object('locations/' + client.$key + '/' + key).set(location)
    // .then(() => {
    //   var hour = new Hour();
    //   hour.open = '9:00 AM';
    //   hour.close = '6:00 PM';
    //   hour.days = 'Monday - Friday';
    //   hour.ldJsonFormat = 'Mo-Fr 9:00-18:00';
    //   this.saveOfficeHour(hour, client.$key, key).then(() => {
    //     hour.open = '9:00 AM';
    //     hour.close = '4:00 PM';
    //     hour.days = 'Saturday';
    //     hour.ldJsonFormat = 'Sa 9:00-16:00';
    //     this.saveOfficeHour(hour, client.$key, key).then(() => {
    //       hour.open = '6:00 AM';
    //       hour.close = '10:00 PM';
    //       hour.days = 'Monday - Friday';
    //       hour.ldJsonFormat = 'Mo-Fr 6:00-22:00';
    //       this.saveGateHour(hour, client.$key, key);
    //     });
    //   });
    // });
  }

  deleteLocation(client, location) {
    return this.db.list('locations/' + client.$key + '/' + location.$key).remove();
  }

  deleteLocationReviewsFromClient(client, location) {
    return this.db.list('facilities/' + client.$key + '/reviews/' + location.$key).remove();
  }

  deleteEmailsByLocation(client, location) {
    return this.db.list('emails/' + client.$key + '/' + location.$key).remove();
  }

  updateLocationSmsReminders(client, location: LocationInfo) {
    return this.db.object('locationSmsReminders/' + client.$key + '/' + location.$key).set(location.isSmsReminders);
  }

  updateLocation(client, location, locationKey?) {
    return this.db.list('locations/' + client.$key).update(locationKey || location.$key, location);
  }

  updateLocationXps(client, location) {
    return this.db.object('locations/' + client.$key + '/' + location.$key + '/xpsInfo').set(location.xpsInfo);
  }

  updateClientXps(client) {
    return this.db.object('facilities/' + client.$key + '/xpsInfo').set(client.xpsInfo);
  }

  updateLocationPixel(client, location) {
    return this.db.object('locations/' + client.$key + '/' + location.$key + '/facebookPixelInfo').set(location.facebookPixelInfo);
  }

  updateClientPixel(client) {
    return this.db.object('facilities/' + client.$key + '/facebookPixelInfo').set(client.facebookPixelInfo);
  }

  updateClientPodium(client) {
    return this.db.object('facilities/' + client.$key + '/podiumInfo').set(client.podiumInfo);
  }

  updateLocationPodium(client, location) {
    return this.db.object('locations/' + client.$key + '/' + location.$key + '/podiumInfo').set(location.podiumInfo);
  }

  loginUser(email, password) {
    return this.auth.auth.signInWithEmailAndPassword(email, password);
  }

  getUserData(uid) {
    return this.db.object('users/' + uid);
  }

  logout() {
    return this.auth.auth.signOut();
  }

  listenForCaches(clientKey) {
    console.time('total cache update time');
    let originalTimes: {
      updateCacheAllTimeFinished: number,
      updateCacheAllError?: string,
      updateCacheAvailableTimeFinished: number,
      updateCacheAvailableError?: string,
      updateCacheDiscountsTimeFinished: number,
      updateCacheDiscountsError?: string,
      updateCacheInsuranceTimeFinished: number,
      updateCacheInsuranceError?: string
    };
    let sub = this.db.object(`cacheFinishedListening/${ clientKey }`).subscribe(async (listener: {
      updateCacheAllTimeFinished: number,
      updateCacheAllError?: string,
      updateCacheAvailableTimeFinished: number,
      updateCacheAvailableError?: string,
      updateCacheDiscountsTimeFinished: number,
      updateCacheDiscountsError?: string,
      updateCacheInsuranceTimeFinished: number,
      updateCacheInsuranceError?: string
    }) => {
      if (!listener) {
        listener = {
          updateCacheAllTimeFinished: 0,
          updateCacheAvailableTimeFinished: 0,
          updateCacheDiscountsTimeFinished: 0,
          updateCacheInsuranceTimeFinished: 0
        };
      }
      if (!originalTimes) {
        originalTimes = listener;
      }
      else {
        if (listener.updateCacheDiscountsTimeFinished > originalTimes.updateCacheDiscountsTimeFinished) {
          this.openSnackBar('Discounts Cache Updated Successfully', 'Close', 4000);
          console.info('Discounts Cache Updated Successfully', listener.updateCacheDiscountsTimeFinished);
          originalTimes.updateCacheDiscountsTimeFinished = listener.updateCacheDiscountsTimeFinished;
        }
        else if (listener.updateCacheDiscountsError !== originalTimes.updateCacheDiscountsError) {
          this.openSnackBar('Error in Discounts Cache, Check Console', 'Close', 4000);
          console.log('updateCacheDiscountsError', listener.updateCacheDiscountsError);
        }

        if (listener.updateCacheInsuranceTimeFinished > originalTimes.updateCacheInsuranceTimeFinished) {
          this.openSnackBar('Insurance Cache Updated Successfully', 'Close', 4000);
          console.info('Insurance Cache Updated Successfully', listener.updateCacheInsuranceTimeFinished);
          originalTimes.updateCacheInsuranceTimeFinished = listener.updateCacheInsuranceTimeFinished;
        }
        else if (listener.updateCacheInsuranceError !== originalTimes.updateCacheInsuranceError) {
          this.openSnackBar('Error in Insurance Cache, Check Console', 'Close', 4000);
          console.log('updateCacheInsuranceError', listener.updateCacheInsuranceError);
        }

        if (listener.updateCacheAllTimeFinished > originalTimes.updateCacheAllTimeFinished) {
          this.openSnackBar('All Units Cache Updated Successfully', 'Close', 4000);
          console.info('All Units Cache Updated Successfully', listener.updateCacheAllTimeFinished);
          originalTimes.updateCacheAllTimeFinished = listener.updateCacheAllTimeFinished;
        }
        else if (listener.updateCacheAllError !== originalTimes.updateCacheAllError) {
          this.openSnackBar('Error in All Units Cache, Check Console', 'Close', 4000);
          console.log('updateCacheAllError', listener.updateCacheAllError);
        }

        if (listener.updateCacheAvailableTimeFinished > originalTimes.updateCacheAvailableTimeFinished) {
          // this is last
          this.openSnackBar('Available Units Cache Updated Successfully', 'Close', 4000);
          console.info('Available Units Cache Updated Successfully', listener.updateCacheAvailableTimeFinished);
          console.timeEnd('total cache update time')
          originalTimes.updateCacheAvailableTimeFinished = listener.updateCacheAvailableTimeFinished;
          sub.unsubscribe();
          await this.db.database.ref(`cacheFinishedListening/${ clientKey }`).update({
            updateCacheAllError: null,
            updateCacheAvailableError: null,
            updateCacheDiscountsError: null,
            updateCacheInsuranceError: null,
          });
        }
        else if (listener.updateCacheAvailableError !== originalTimes.updateCacheAvailableError) {
          this.openSnackBar('Error in Available Units Cache, Check Console', 'Close', 4000);
          console.log('updateCacheAvailableError', listener.updateCacheAvailableError);
          sub.unsubscribe();
        }
      }
    },
      error => console.error(error)
    );
  }

  openSnackBar(message: string, action: string = 'Close', duration = 2000) {
    this.snackBar.open(message, action, {
      duration: duration,
    });
  }

  saveObjectToFacilityFirebase(clientCode, data, table) {
    let url: string;
    url = this.baseUrl + 'push-object-to-fb';

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, {
      "clientCode": clientCode,
      "data": data,
      "table": table,
      "env": environment.env
    }, this.options).map((res) => res.json());
  }

  getUnitSizes(clientCode, locationKey) {
    let url: string;
    url = this.baseUrl + 'get-object-from-firebase';

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*"
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, {
      "apiUrl": url,
      "table": 'unitSizes/' + locationKey,
      "clientCode": clientCode
    }, this.options).map((res) => res.json());
  }

  getAllUnitSizes(clientCode) {
    let url: string;
    url = this.baseUrl + 'get-object-from-firebase';

    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*"
    });
    this.options = new RequestOptions({ headers: this.headers });
    return this.http.post(url, {
      "apiUrl": url,
      "table": 'unitSizes',
      "clientCode": clientCode
    }, this.options).map((res) => res.json());
  }

  autoSaveReviewSettings(facilityReviewsData) {
    this.saveReviewSettings(facilityReviewsData.facilityKey, facilityReviewsData.locationCode, facilityReviewsData).then((data) => {
      this.openSnackBar('Review Settings Updated');
      // this.isLoading = false;
    });
  }

  submitReviewSettingsBatch(clientCode, facilityReviewsData) {
    this.reviewSettingsSubmittedCount++;
    this.globalReviewsLoading = true;
    console.log('submitReviewSettingsBatch start')
    this.bl.commitBatch(facilityReviewsData.batchId, clientCode, facilityReviewsData.locationCode, facilityReviewsData.locationName).toPromise().then((batch) => {
      if (batch['ret'] == 'success') {
        facilityReviewsData.activeIndex = 3;
        console.log('submitReviewSettingsBatch end')

        this.autoSaveReviewSettings(facilityReviewsData);
        this.getReviewSettingsResults(clientCode, facilityReviewsData);
      }
      else {
        this.isLoading = false;
      }
    })
  }

  getReviewSettingsResults(clientCode, facilityReviewsData) {
    console.log('getReviewSettingsResults start')
    this.getClientInfo(facilityReviewsData.facilityKey).subscribe(client => {
      facilityReviewsData.activeIndex = 4;
      console.log(facilityReviewsData);
      console.log('getReviewSettingsResults end')
      this.autoSaveReviewSettings(facilityReviewsData);
      this.getReviewSettingsResult(clientCode, facilityReviewsData);
    });
  }

  getReviewSettingsResult(clientCode, facilityReviewsData) {
    console.log(facilityReviewsData)

    return this.bl.getResults(facilityReviewsData.batchId, clientCode, facilityReviewsData.locationCode, facilityReviewsData.locationName)
      .toPromise().then((data) => {
        // this.showLoading = false;
        this.globalReviewsLoading = false;
        if (data['ret'] == 'success') {
          this.saveReviewSettingsResult(data['data'], facilityReviewsData);
        }
        else {
          this.globalReviewsLoading = false;
          this.isLoading = false;
        }
        // else {
        //   setTimeout(() => {
        //     this.getReviewSettingsResult(facilityReviewsData);
        //   }, 10000);
        // }
      });
  }

  saveReviewSettingsResult(reviews, facilityReviewsData) {
    console.log(facilityReviewsData)
    this.saveReviews(facilityReviewsData.facilityKey, facilityReviewsData.locationCode, reviews).then((data) => {
      this.saveReviewsFacility(facilityReviewsData.facilityKey, facilityReviewsData.locationCode, reviews).then((data2) => {
        this.openSnackBar('Review Settings Updated');
        facilityReviewsData.status = 'done';
        this.autoSaveReviewSettings(facilityReviewsData);
        this.reviewSettingsSubmittedCount--;
        if (this.reviewSettingsSubmittedCount == 0) {
          this.globalReviewsLoading = false;
        }
        this.isLoading = false;
      });
    });
  }

  getDataForCopyToProd(clientData: Client) {
    let rtn = {
      blogPosts: null,
      blogUrlRedirects: null,
      clientCode: clientData.code,
      locations: null,
      locationForms: null,
      locationsEsignInfo: null,
      emails: null
    };

    const observables = [
      this.db.object('blogPosts/' + clientData.$key),
      this.db.object('locations/' + clientData.$key),
      this.db.object('locationForms/' + clientData.$key),
      this.db.object('locationsEsignInfo/' + clientData.$key),
      this.db.object('emails/' + clientData.$key),
    ];

    console.log('about to forkJoin');

    return new Promise<any>((resolve, reject) => {
      Observable.combineLatest(observables).subscribe(responses => {
        // responses array will be in the same order as requests
        console.log('responses:', responses);
        const blogPosts = responses[0];
        const locations = responses[1];
        const locationForms = responses[2];
        const locationsEsignInfo = responses[3];
        const emails = responses[4];

        if (blogPosts.$exists()) {
          rtn.blogPosts = blogPosts;
          delete rtn.blogPosts.$key;
          delete rtn.blogPosts.$exists;
        }

        if (locations.$exists()) {
          rtn.locations = locations;
          delete rtn.locations.$key;
          delete rtn.locations.$exists;
        }

        if (locationForms.$exists()) {
          rtn.locationForms = locationForms;
          delete rtn.locationForms.$key;
          delete rtn.locationForms.$exists;
        }

        if (locationsEsignInfo.$exists()) {
          rtn.locationsEsignInfo = locationsEsignInfo;
          delete rtn.locationsEsignInfo.$key;
          delete rtn.locationsEsignInfo.$exists;
        }

        if (emails.$exists()) {
          rtn.emails = emails;
          delete rtn.emails.$key;
          delete rtn.emails.$exists;
        }

        resolve(rtn);
      },
        error => {
          console.log('forkJoin error:', error);
          reject(error);
        }
      );
    });
  }

  async softDeleteClient(clientData: Client) {
    let numLocations = 0;
    try {

      this.headers = new Headers({
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
      });
      this.options = new RequestOptions({ headers: this.headers })
      const params = {
        env: environment.env,
        clientCode: clientData.code,
        action: 'disable'
      };

      var [
        blogPosts,
        locations,
        locationForms,
        locationsEsignInfo,
        emails,
        facility,
        agendaResponse,
        freshpingResponse
      ] = await new Promise<any>((resolve, reject) => {
        Observable.combineLatest([
          this.db.object('blogPosts/' + clientData.$key),
          this.db.object('locations/' + clientData.$key),
          this.db.object('locationForms/' + clientData.$key),
          this.db.object('locationsEsignInfo/' + clientData.$key),
          this.db.object('emails/' + clientData.$key),
          this.db.object('facilities/' + clientData.$key),
          this.http.post('https://agenda.storpug.com/v1/enable-reviews-auto-update', params, this.options),
          this.aws.removeFreshpingCheck(clientData.freshpingId),
        ])
          .map(arr => arr.map(r => _.isFunction(r.$exists) && r.$exists() ? r : null))
          .subscribe(
            responses => resolve(responses),
            error => reject(error)
          );
      });
    }
    catch (error) {
      console.log('aborting, error caught getting client data:', error);
      return;
    }

    numLocations = Object.keys(locations).length;

    try {
      await new Promise<any>((resolve, reject) => {
        Observable.combineLatest([
          this.db.object('inactive/blogPosts/' + clientData.$key).set(blogPosts),
          this.db.object('inactive/locations/' + clientData.$key).set(locations),
          this.db.object('inactive/locationForms/' + clientData.$key).set(locationForms),
          this.db.object('inactive/locationsEsignInfo/' + clientData.$key).set(locationsEsignInfo),
          this.db.object('inactive/emails/' + clientData.$key).set(emails),
          this.db.object('inactive/facilities/' + clientData.$key).set(facility),
          this.db.object('inactive/facilityKeys/' + clientData.code).set(clientData.$key),
        ]).subscribe(
          responses => resolve(console.log(responses)),
          error => reject(error)
        );
      });
    } catch (error) {
      console.log('aborting, error caught copying client data:', error);
      return;
    }

    try {
      await this.deleteClient(clientData);
      return numLocations;
    }
    catch (error) {
      console.log('error caught deleting client, oh dear this could be bad...');
    }
  }

  deleteClient(clientData: Client) {
    const observables = [
      this.db.object('blogPosts/' + clientData.$key).remove(),
      this.db.object('locations/' + clientData.$key).remove(),
      this.db.object('locationForms/' + clientData.$key).remove(),
      this.db.object('locationsEsignInfo/' + clientData.$key).remove(),
      this.db.object('emails/' + clientData.$key).remove(),
      this.db.object('facilities/' + clientData.$key).remove(),
      this.db.object('facilityKeys/' + clientData.code).remove(),
    ];

    console.log('about to forkJoin')
    return new Promise<void>((resolve, reject) => {
      Observable.combineLatest(observables).subscribe(
        async responses => {
          // responses array will be in the same order as requests
          console.log('delete responses (should all be undefined):', responses);
          try {
            await this.removeClientSoftware(clientData)
          } catch (e) {
            console.log('error caught removing property software', e)
          }
          resolve();
        },
        error => {
          console.log('deleteClient error:', error);
          reject(error);
        }
      );
    })
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/firebase.service.ts